<form *ngIf="!!formGroup" #form="ngForm" [formGroup]="formGroup">
  <div *ngFor="let field of formFields; let i = index">
    <div class="padding-bottom" *ngIf="field.type === formFieldType.INPUT">
      <!-- Input Field -->
      <ds-form-field>
        <ds-input-label>{{ field.label }}</ds-input-label>
        <input
          dsInput
          type="text"
          [id]="field.id"
          [name]="field.name"
          [formControlName]="field.name"
          [value]="field.value"
          [dsMask]="field.mask"
          [customMask]="field.customMask"
          [minlength]="field.minLength!"
          [placeholder]="field.placeholder ? field.placeholder : ''"
          [customState]="formGroup.get(field.name)?.invalid ? 'error' : null"
          (keydown.enter)="onInputEnterKey()"
        />
        <ds-error
          *ngIf="formGroup.get(field.name)?.invalid"
          [errorMessage]="getErrorMessage(getFormControl(field.name), field)"
        ></ds-error>
      </ds-form-field>
    </div>
    <div class="padding-bottom" *ngIf="field.type === formFieldType.SELECT">
      <!-- Select Dropdown -->
      <ds-form-field>
        <ds-input-label>{{ field.label }}</ds-input-label>
        <select
          dsNativeControl
          [id]="field.id"
          [name]="field.name"
          [formControlName]="field.name"
          [customState]="formGroup.get(field.name)?.invalid ? 'error' : null"
        >
          <option
            *ngFor="let option of field.options"
            value="{{ option.value }}"
          >
            {{ option.label }}
          </option>
        </select>
        <ds-error
          *ngIf="formGroup.get(field.name)?.invalid"
          [errorMessage]="getErrorMessage(getFormControl(field.name), field)"
        ></ds-error>
      </ds-form-field>
    </div>
  </div>
  <ucx-credit-card
    *ngIf="creditCardConfig && isCreditCard"
    [creditCardInfo]="creditCardConfig"
    [creditCardForm]="formGroup"
  ></ucx-credit-card>

  <div class="padding-bottom">
    <button
      ds-button
      variant="primary"
      class="width-100 inherit-font-size"
      [disabled]="isSubmitBtnDisabled"
      (click)="onFormSubmit()"
    >
      {{ okBtnText }}
    </button>
  </div>
  <div class="padding-bottom" *ngIf="!isCancelBtnHidden">
    <button
      ds-button
      variant="secondary"
      class="width-100 inherit-font-size"
      (click)="onCancel()"
    >
      {{ cancelBtnText }}
    </button>
  </div>
</form>
